// Module
var code = "<a data-bind=\"click: Click\" data-testid=\"edit.cancel\" class=\"text-sm sps-btn sps-btn-outline btn-color-static-cancel cancelBtn\" tabindex=\"-1\" id=\"cancelBtn\"> <i class=\"fa fa-close\"></i><span><!-- ko text: _labels.CANCEL --><!-- /ko --></span> </a>";
// Exports
export default code;